export default "__VITE_ASSET__BiLLS9kl__"